import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch('assets/config/configurationOK.json')
  .then((res) => res.json())
  .then((configuration) => {
    if (environment.production) {
      enableProdMode();
    }
    environment.mobileTrackerUrl= configuration.mobileTrackerUrl;
    environment.budgetcalcUrl= configuration.budgetcalcUrl;
    environment.taxRate= configuration.taxRate;
    environment.minPrepayment= configuration.minPrepayment;
    environment.maxLengthFreeText= configuration.maxLengthFreeText;
    environment.startpagepaths= configuration.startpagepaths;

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
